/**
 * Réponse d'erreur d'`animation-publish` → message lisible par l'admin.
 * Sans dépendance (testable sans client Supabase).
 */

export const PUBLISH_ERROR_MESSAGES: Record<string, string> = {
  invalid_draft: 'Le brouillon a des erreurs : le serveur refuse de le publier.',
  not_reviewed: 'Relis l’animation et coche « J’ai relu » avant de la publier.',
  draft_changed: 'Le brouillon vient de changer : relis-le puis publie à nouveau.',
  generating: 'Une génération est en cours : attends qu’elle finisse.',
  slug_conflict: 'Le lien de l’animation vient d’être pris par une autre publication : réessaie.',
  archived: 'Animation archivée.',
  no_draft: 'Rien à publier : l’animation n’a pas encore de brouillon.',
  not_found: 'Animation introuvable.',
  forbidden: 'Réservé aux administrateurs.',
};

/**
 * `code` = champ `error` de la réponse, `detail` = son `message` (pour
 * `invalid_draft` : la 1re erreur de validation, à montrer telle quelle).
 */
export function publishErrorMessage(
  code: string | undefined,
  detail: string | undefined,
  fallback: string,
): string {
  const known = code ? PUBLISH_ERROR_MESSAGES[code] : undefined;
  if (!known) return detail || code || fallback;
  if (code === 'invalid_draft' && detail) return `${known} 1re erreur : ${detail}`;
  return known;
}
